/**
 * Converts the first letter of the string to uppercase
 */
export const capitalizeStr = (str: string) => {
  if (typeof str !== "string") return "";

  const trimmedStr = str.trim();

  return (
    trimmedStr.charAt(0).toLocaleUpperCase() +
    trimmedStr.slice(1).toLocaleLowerCase()
  );
};